import { createStore as reduxCreateStore, applyMiddleware } from 'redux';
import { composeWithDevTools } from 'redux-devtools-extension/logOnlyInProduction';
import { createEpicMiddleware } from 'redux-observable';
import createSagaMiddleware from 'redux-saga';

import envData from '../../../config/env.json';
import { isBrowser } from '../../utils';
import rootEpic from './root-epic';
import rootReducer from './root-reducer';
import rootSaga from './root-saga';

const { environment } = envData;

const clientSide = isBrowser();

export const createStore = () => {
  const sagaMiddleware = createSagaMiddleware({
    context: {
      document: clientSide ? document : {}
    }
  });

  const epicMiddleware = createEpicMiddleware({
    dependencies: {
      window: clientSide ? window : {},
      location: clientSide ? window.location : {},
      document: clientSide ? document : {}
    }
  });

  const composeEnhancers = composeWithDevTools({
    // options like actionSanitizer, stateSanitizer
  });

  const middleware = applyMiddleware(sagaMiddleware, epicMiddleware);

  const store =
    environment === 'production'
      ? reduxCreateStore(rootReducer, middleware)
      : reduxCreateStore(rootReducer, composeEnhancers(middleware));

  sagaMiddleware.run(rootSaga);
  epicMiddleware.run(rootEpic);

  if (module.hot) {
    module.hot.accept('./root-reducer', () => {
      const nextRootReducer = require('./root-reducer');
      store.replaceReducer(nextRootReducer);
    });
  }

  return store;
};
